import { render, staticRenderFns } from "./FormBuilderGui.vue?vue&type=template&id=989828fe&scoped=true&"
import script from "./FormBuilderGui.vue?vue&type=script&lang=js&"
export * from "./FormBuilderGui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989828fe",
  null
  
)

export default component.exports